// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__gyTo9","active":"Paginator_active__S2dTg","disabled":"Paginator_disabled__27__W"};